export const localStorageKeys = {
  notificationDismissed: 'notificationDismissed-',
  alertDismissed: 'alertDismissed-',
};
